<template >
  <div>
    <CCard>
      <CCardBody>
        <CRow>
          <CCol>
            <CSelect label="Campus" :options="campus"/>
          </CCol>
          <CCol col="3">
            <CInput
                label="AcademicYear"
                placeholder="AcademicYear"
                type="number" min="2017" max="2100"
            >
            </CInput>
          </CCol>
          <CCol col="3">
            <CSelect label="Semester" :options="semesters"/>
          </CCol>
        </CRow>
        <CRow>

        </CRow>

        <CRow>
          <CCol>
            <CSelect label="faculty" :options="facultys"/>
          </CCol>

        </CRow>

        <CRow>
          <CCol>
            <CSelect label="department" :options="departments"/>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>

import {mapGetters} from 'vuex'

export default {
  name: 'SearchEduction',
  data: function () {
    return {
      semesters:[1,2,3]
    }
  },
  mounted() {

  },

  created() {
    this.onInit();
  },

  beforeDestroy() {

  },

  methods: {

    onInit(){
      this.$store.dispatch("setting/configCampus")
      this.$store.dispatch("setting/configFacultys")
      this.$store.dispatch("setting/configDepartments")
    },


  },

  computed: {
    ...mapGetters({
      campus: "setting/campus",
      facultys: "setting/facultys",
      departments: "setting/departments",
    })
  },

  watch: {

  }

}
</script>

